import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './navbar.css';
import logo from '../assets/logo.png';

const Navbar = () => {
  const location = useLocation();

  const links = [
    { label: 'Home',       path: '/'           },
    { label: 'Exhibitors', path: '/exhibitors' },
    { label: 'Tickets',    path: '/tickets'    },
    { label: 'Schedule',   path: '/schedule'   },
    { label: 'Contact',    path: '/contact'    },
  ];

  return (
    <nav className="navbar" aria-label="Main navigation">

      {/* ── LEFT: Logo ── */}
      <Link to="/" className="navbar-logo">
        <div className="navbar-logo-box">
          <img src={logo} alt="Egypt International Exhibition logo" className="navbar-logo-img" />
        </div>
        <div className="navbar-logo-textblock">
          <span className="navbar-logo-title">Egypt International Exhibition</span>
          <span className="navbar-logo-sub">Garment &amp; Textile Machinery</span>
        </div>
      </Link>

      {/* ── CENTRE: Nav links ── */}
      <ul className="navbar-links">
        {links.map(({ label, path }) => (
          <li key={path}>
            <Link
              to={path}
              className={
                'navbar-link' +
                (location.pathname === path ? ' navbar-link--active' : '')
              }
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      {/* ── RIGHT: CTA ── */}
      <Link to="/tickets" className="navbar-cta">
        Book Ticket
      </Link>

    </nav>
  );
};

export default Navbar;
